module.exports = "/assets/182a69cc186c05efc2239443be8364bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2B.png
// module id = 977
// module chunks = 0